import { render, staticRenderFns } from "./Decennial.vue?vue&type=template&id=02b0b003&"
import script from "./Decennial.vue?vue&type=script&lang=js&"
export * from "./Decennial.vue?vue&type=script&lang=js&"
import style0 from "./Decennial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports